/* eslint-disable valid-typeof */
function helperCreateInTypeof (type) {
  return function (obj) {
    return typeof obj === type
  }
}

module.exports = helperCreateInTypeof



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/base/helperCreateInTypeof.js
// module id = WIJ6
// module chunks = 0